import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Categories() {
  const categories = [
    {
      title: "Custom T-Shirts",
      image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=200&h=200&fit=crop",
      items: "80+ items",
      type: "list",
      list: ["Shortsleeve Tees", "Longsleeve Tees", "Tank Tops", "Youth T-Shirts"]
    },
    {
      title: "Custom Mugs",
      image: "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=200&h=200&fit=crop",
      items: "50+ items",
      type: "description",
      description: "Our online tools make the process as simple and clear as possible."
    },
    {
      title: "Custom Hats",
      image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=200&h=200&fit=crop",
      items: "80+ items",
      type: "list",
      list: ["Baseball Caps", "Beanies", "Snapbacks", "Trucker Hats"]
    },
    {
      title: "Custom Boxes",
      image: "https://images.unsplash.com/photo-1565992441121-4367c2967103?w=200&h=200&fit=crop",
      items: "50+ items",
      type: "description",
      description: "Our online tools make the process as simple and clear as possible."
    }
  ];

  return (
    <div className="w-full py-8 md:py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-8 md:mb-12">
          <h5 className="text-sm md:text-lg font-medium text-black mb-2">
            <span className="text-[#6cc5bf] text-2xl md:text-4xl">_</span> All print categories
          </h5>
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-black capitalize">
            Explore all categories
          </h1>
        </div>

        {/* Swiper */}
        <Swiper
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          modules={[Pagination, Autoplay]}
          spaceBetween={16}
          breakpoints={{
            0: { direction: "horizontal", slidesPerView: 1 },
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { direction: "vertical", slidesPerView: 1 }
          }}
          className="w-full h-auto lg:h-[700px]"
          style={{
            '--swiper-pagination-color': '#6cc5bf',
            '--swiper-pagination-bullet-inactive-color': '#999999',
          }}
        >
          {[1, 2, 3].map((slideNum) => (
            <SwiperSlide key={slideNum}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                {categories.map((category, idx) => (
                  <div
                    key={idx}
                    className="border bg-white p-4 md:p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow relative"
                  >
                    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">

                      {/* Image */}
                      <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 flex-shrink-0">
                        <img
                          src={category.image}
                          alt={category.title}
                          className="w-full h-full object-cover rounded-lg"
                        />
                      </div>

                      {/* Content */}
                      <div className="flex-1">
                        <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-2">
                          {category.title}
                        </h2>

                        {category.type === "list" ? (
                          <ul className="space-y-1 text-sm md:text-base text-gray-600">
                            {category.list.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-sm md:text-base text-gray-600">
                            {category.description}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Badge */}
                    <span className="absolute top-3 right-3 px-3 py-1 bg-[#6cc5bf] rounded text-xs md:text-sm text-white">
                      {category.items}
                    </span>
                  </div>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </div>
  );
}

export default Categories;
